import { render } from "./CreatedAt.vue?vue&type=template&id=f941158c"
import script from "./CreatedAt.vue?vue&type=script&lang=js"
export * from "./CreatedAt.vue?vue&type=script&lang=js"

import "./CreatedAt.vue?vue&type=style&index=0&id=f941158c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__